/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import Styles from '../../css/LoanInformation.module.css';

import { useLoanInformationContext } from '../../contexts/LoanInformationContext';
import EnvelopeWithBox from '../EnvelopeWithBox';
import { isStrEmptyOrNull } from '../../common/UtilityFunctions';

const SuccessorInfo = () => {
  const { servicingData, handleServicingChange, loanContacts, handleLoanContactChange } = useLoanInformationContext();

  return (
    <EnvelopeWithBox blockName='Successor in Interest/Trust Information'>
      <div className={Styles.loanInfoTable}>
        <div className={Styles.leftColumn}>
          <table className={Styles.loanInfoTableSection}>
            <tbody>
              <tr>
                <th>Trustee Name: </th>
                <td>
                  <input
                    type='text'
                    name='contactPersonFirstName'
                    value={loanContacts?.TE?.contactPersonFirstName || ''}
                    onChange={(e) => {
                      handleLoanContactChange('edit', 'TE.contactPersonFirstName', e.target.value);
                      if (!isStrEmptyOrNull(e.target.value) && !loanContacts?.TE?.active) {
                        handleLoanContactChange('edit', 'TE.active', true);
                      }
                    }}
                    placeholder='Enter trustee first name'
                  />
                  <input
                    type='text'
                    name='contactPersonLastName'
                    value={loanContacts?.TE?.contactPersonLastName || ''}
                    onChange={(e) => {
                      handleLoanContactChange('edit', 'TE.contactPersonLastName', e.target.value);
                      if (!isStrEmptyOrNull(e.target.value) && !loanContacts?.TE?.active) {
                        handleLoanContactChange('edit', 'TE.active', true);
                      }
                    }}
                    placeholder='Enter trustee last name'
                  />
                </td>
              </tr>
              <tr>
                <th>Trustee Company Name: </th>
                <td>
                  <input
                    type='text'
                    name='name1'
                    value={loanContacts?.TE?.name1 || ''}
                    onChange={(e) => {
                      handleLoanContactChange('edit', 'TE.name1', e.target.value);
                      if (!isStrEmptyOrNull(e.target.value) && !loanContacts?.TE?.active) {
                        handleLoanContactChange('edit', 'TE.active', true);
                      }
                    }}
                    placeholder='Enter trustee company name'
                  />
                </td>
              </tr>
              <tr>
                <th>Email: </th>
                <td>
                  <input
                    type='text'
                    name='contactPersonEmail'
                    value={loanContacts?.TE?.contactPersonEmail || ''}
                    onChange={(e) => {
                      handleLoanContactChange('edit', 'TE.contactPersonEmail', e.target.value);
                      if (!isStrEmptyOrNull(e.target.value) && !loanContacts?.TE?.active) {
                        handleLoanContactChange('edit', 'TE.active', true);
                      }
                    }}
                    placeholder='Enter trustee email'
                  />
                </td>
              </tr>
              <tr>
                <th>Mailing Address 1: </th>
                <td>
                  <input
                    type='text'
                    name='address1'
                    value={loanContacts?.TE?.address1 || ''}
                    onChange={(e) => {
                      handleLoanContactChange('edit', 'TE.address1', e.target.value);
                      if (!isStrEmptyOrNull(e.target.value) && !loanContacts?.TE?.active) {
                        handleLoanContactChange('edit', 'TE.active', true);
                      }
                    }}
                    placeholder='Enter address'
                  />
                </td>
              </tr>
              <tr>
                <th>City/State/Zip: </th>
                <td>
                  <input
                    type='text'
                    name='city'
                    value={loanContacts?.TE?.city || ''}
                    onChange={(e) => {
                      handleLoanContactChange('edit', 'TE.city', e.target.value);
                      if (!isStrEmptyOrNull(e.target.value) && !loanContacts?.TE?.active) {
                        handleLoanContactChange('edit', 'TE.active', true);
                      }
                    }}
                    placeholder='Enter city'
                  />
                  <input
                    type='text'
                    name='companyState'
                    value={loanContacts?.TE?.companyState || ''}
                    onChange={(e) => {
                      handleLoanContactChange('edit', 'TE.companyState', e.target.value);
                      if (!isStrEmptyOrNull(e.target.value) && !loanContacts?.TE?.active) {
                        handleLoanContactChange('edit', 'TE.active', true);
                      }
                    }}
                    placeholder='Enter state'
                  />
                  <input
                    type='text'
                    name='zip'
                    value={loanContacts?.TE?.zip || ''}
                    onChange={(e) => {
                      handleLoanContactChange('edit', 'TE.zip', e.target.value);
                      if (!isStrEmptyOrNull(e.target.value) && !loanContacts?.TE?.active) {
                        handleLoanContactChange('edit', 'TE.active', true);
                      }
                    }}
                    placeholder='Enter ZIP'
                  />
                </td>
              </tr>
              <tr>
                <th>Can Contact SII: </th>
                <td className={Styles.radioOptionsData}>
                  <div className={Styles.radioOptionsContainer}>
                    <label className={Styles.radioOptionsLabel}>
                      <input
                        type='radio'
                        name={'printSIIOnLetters'}
                        value='true'
                        checked={servicingData?.printSIIOnLetters}
                        onChange={(e) => handleServicingChange('edit', 'printSIIOnLetters', true)}
                        className={Styles.radioOptionsInput}
                      ></input>
                      Yes
                    </label>
                    <label className={Styles.radioOptionsLabel}>
                      <input
                        type='radio'
                        name={'printSIIOnLetters'}
                        value='false'
                        checked={!servicingData?.printSIIOnLetters}
                        onChange={(e) => handleServicingChange('edit', 'printSIIOnLetters', false)}
                        className={Styles.radioOptionsInput}
                      ></input>
                      No
                    </label>
                  </div>
                </td>
              </tr>
            </tbody>
            <tr>
              <td colSpan={2} style={{ height: '20px' }}></td>
            </tr>
          </table>
        </div>
      </div>
    </EnvelopeWithBox>
  );
};

export default SuccessorInfo;
